import { render, staticRenderFns } from "./discountReceived.vue?vue&type=template&id=8c04c832&scoped=true&"
import script from "./discountReceived.vue?vue&type=script&lang=js&"
export * from "./discountReceived.vue?vue&type=script&lang=js&"
import style0 from "./discountReceived.vue?vue&type=style&index=0&id=8c04c832&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c04c832",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SvgIcon: require('/app/components/svgIcon/svgIcon.vue').default})
